// ButtonTag.js
import React from 'react';

const ButtonReport = ({type, text, id, name, onClick, areaLabel }) => (
<button
  type={type}
  id={id}
  name={name}
  onClick={onClick}
  aria-label={areaLabel}
  className="text-center text-white font-semibold text-lg px-2 py-1 rounded-md 
             bg-gradient-to-r from-blue-900 via-teal-400 to-purple-900 
             shadow-md transition-all duration-300 ease-in-out 
             hover:from-pink-500 hover:to-yellow-500 
             hover:scale-105 hover:shadow-xl"
>
  {text}
</button>

);

export default ButtonReport;






